export type IconsId =
  | 'abv'
  | 'add'
  | 'advanced-notes'
  | 'alcohol'
  | 'alert-circle-filled'
  | 'alert-circle'
  | 'alert-triangle'
  | 'amex'
  | 'app-subscription'
  | 'apple-pay'
  | 'armoa'
  | 'arrow-left'
  | 'award-winning'
  | 'award'
  | 'back'
  | 'biodynamic'
  | 'birthday-bonus'
  | 'blend-type'
  | 'bottle-glass'
  | 'bottle'
  | 'boxes'
  | 'calendar-clock'
  | 'calendar'
  | 'camera'
  | 'caps-lock'
  | 'cart'
  | 'case'
  | 'check'
  | 'Checkbox'
  | 'cheers'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'chocolate'
  | 'choice-check'
  | 'choice-uncheck'
  | 'circle-chevron-left'
  | 'circle-chevron-right'
  | 'clear-circle'
  | 'close'
  | 'convenient-delivery'
  | 'cork-screw'
  | 'coupons'
  | 'credit-card'
  | 'customer-services'
  | 'customize'
  | 'customized-selections'
  | 'delete'
  | 'diamond'
  | 'discover'
  | 'dot-menu'
  | 'dots-menu'
  | 'droplet'
  | 'edit'
  | 'email'
  | 'envelope-box'
  | 'envelope'
  | 'expand'
  | 'eye'
  | 'facebook'
  | 'file-user'
  | 'filter'
  | 'flexibility'
  | 'free-delivery'
  | 'gift'
  | 'glass'
  | 'glasses'
  | 'google-pay'
  | 'grape'
  | 'green-tick'
  | 'hamburger-menu'
  | 'hand-truck'
  | 'heart-solid'
  | 'heart'
  | 'help-circle'
  | 'hide-password'
  | 'home'
  | 'homepage-customisation'
  | 'info-circle'
  | 'information-circle'
  | 'instagram'
  | 'kosher'
  | 'label-scanner'
  | 'last-sold-bg'
  | 'ligntning-solid'
  | 'linked-in'
  | 'live-chat'
  | 'location'
  | 'mastercard'
  | 'menu'
  | 'minus'
  | 'money-back-apac'
  | 'money-back-us'
  | 'money-back'
  | 'mute'
  | 'no-obligation'
  | 'offset-carbon'
  | 'organic'
  | 'packaging-pioneer'
  | 'pad-lock-benefits'
  | 'padlock'
  | 'pause'
  | 'paypal'
  | 'phone-arrow'
  | 'phone-solid'
  | 'phone'
  | 'pioneer'
  | 'placeholder'
  | 'play-video'
  | 'play'
  | 'print'
  | 'question-circle'
  | 'radio-selected'
  | 'radio'
  | 'red-alert-circle-filled'
  | 'restaurant-dishes'
  | 'rossette'
  | 'sale-tag-benefits'
  | 'sale-tag'
  | 'sale'
  | 'satisfaction-guarantee'
  | 'saving'
  | 'savings'
  | 'search'
  | 'share'
  | 'sort'
  | 'star-solid'
  | 'star'
  | 'stwc-blog'
  | 'subscribe-save'
  | 'sustainable'
  | 'target'
  | 'thumbs-down-solid'
  | 'thumbs-down'
  | 'thumbs-up-solid'
  | 'thumbs-up'
  | 'tick-circle-solid'
  | 'tick-circle'
  | 'ticket'
  | 'trending'
  | 'truck-benefits'
  | 'truck-solid'
  | 'truck'
  | 'trust'
  | 'twitter'
  | 'unidentified-country'
  | 'units'
  | 'unlimited-avr'
  | 'unlimited-sale'
  | 'unlimited-save'
  | 'unlimited-stwc'
  | 'unlimited-truck'
  | 'unlimited'
  | 'unltCheckIcon'
  | 'user'
  | 'vegan'
  | 'vegetarian'
  | 'views'
  | 'vinny'
  | 'visa'
  | 'warning'
  | 'wine-colour'
  | 'wine-glass'
  | 'world'
  | 'x-twitter'
  | 'youtube'
  | 'zoom';

export type IconsKey =
  | 'Abv'
  | 'Add'
  | 'AdvancedNotes'
  | 'Alcohol'
  | 'AlertCircleFilled'
  | 'AlertCircle'
  | 'AlertTriangle'
  | 'Amex'
  | 'AppSubscription'
  | 'ApplePay'
  | 'Armoa'
  | 'ArrowLeft'
  | 'AwardWinning'
  | 'Award'
  | 'Back'
  | 'Biodynamic'
  | 'BirthdayBonus'
  | 'BlendType'
  | 'BottleGlass'
  | 'Bottle'
  | 'Boxes'
  | 'CalendarClock'
  | 'Calendar'
  | 'Camera'
  | 'CapsLock'
  | 'Cart'
  | 'Case'
  | 'Check'
  | 'Checkbox'
  | 'Cheers'
  | 'ChevronDown'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronUp'
  | 'Chocolate'
  | 'ChoiceCheck'
  | 'ChoiceUncheck'
  | 'CircleChevronLeft'
  | 'CircleChevronRight'
  | 'ClearCircle'
  | 'Close'
  | 'ConvenientDelivery'
  | 'CorkScrew'
  | 'Coupons'
  | 'CreditCard'
  | 'CustomerServices'
  | 'Customize'
  | 'CustomizedSelections'
  | 'Delete'
  | 'Diamond'
  | 'Discover'
  | 'DotMenu'
  | 'DotsMenu'
  | 'Droplet'
  | 'Edit'
  | 'Email'
  | 'EnvelopeBox'
  | 'Envelope'
  | 'Expand'
  | 'Eye'
  | 'Facebook'
  | 'FileUser'
  | 'Filter'
  | 'Flexibility'
  | 'FreeDelivery'
  | 'Gift'
  | 'Glass'
  | 'Glasses'
  | 'GooglePay'
  | 'Grape'
  | 'GreenTick'
  | 'HamburgerMenu'
  | 'HandTruck'
  | 'HeartSolid'
  | 'Heart'
  | 'HelpCircle'
  | 'HidePassword'
  | 'Home'
  | 'HomepageCustomisation'
  | 'InfoCircle'
  | 'InformationCircle'
  | 'Instagram'
  | 'Kosher'
  | 'LabelScanner'
  | 'LastSoldBg'
  | 'LigntningSolid'
  | 'LinkedIn'
  | 'LiveChat'
  | 'Location'
  | 'Mastercard'
  | 'Menu'
  | 'Minus'
  | 'MoneyBackApac'
  | 'MoneyBackUs'
  | 'MoneyBack'
  | 'Mute'
  | 'NoObligation'
  | 'OffsetCarbon'
  | 'Organic'
  | 'PackagingPioneer'
  | 'PadLockBenefits'
  | 'Padlock'
  | 'Pause'
  | 'Paypal'
  | 'PhoneArrow'
  | 'PhoneSolid'
  | 'Phone'
  | 'Pioneer'
  | 'Placeholder'
  | 'PlayVideo'
  | 'Play'
  | 'Print'
  | 'QuestionCircle'
  | 'RadioSelected'
  | 'Radio'
  | 'RedAlertCircleFilled'
  | 'RestaurantDishes'
  | 'Rossette'
  | 'SaleTagBenefits'
  | 'SaleTag'
  | 'Sale'
  | 'SatisfactionGuarantee'
  | 'Saving'
  | 'Savings'
  | 'Search'
  | 'Share'
  | 'Sort'
  | 'StarSolid'
  | 'Star'
  | 'StwcBlog'
  | 'SubscribeSave'
  | 'Sustainable'
  | 'Target'
  | 'ThumbsDownSolid'
  | 'ThumbsDown'
  | 'ThumbsUpSolid'
  | 'ThumbsUp'
  | 'TickCircleSolid'
  | 'TickCircle'
  | 'Ticket'
  | 'Trending'
  | 'TruckBenefits'
  | 'TruckSolid'
  | 'Truck'
  | 'Trust'
  | 'Twitter'
  | 'UnidentifiedCountry'
  | 'Units'
  | 'UnlimitedAvr'
  | 'UnlimitedSale'
  | 'UnlimitedSave'
  | 'UnlimitedStwc'
  | 'UnlimitedTruck'
  | 'Unlimited'
  | 'UnltCheckIcon'
  | 'User'
  | 'Vegan'
  | 'Vegetarian'
  | 'Views'
  | 'Vinny'
  | 'Visa'
  | 'Warning'
  | 'WineColour'
  | 'WineGlass'
  | 'World'
  | 'XTwitter'
  | 'Youtube'
  | 'Zoom';

export enum Icons {
  Abv = 'abv',
  Add = 'add',
  AdvancedNotes = 'advanced-notes',
  Alcohol = 'alcohol',
  AlertCircleFilled = 'alert-circle-filled',
  AlertCircle = 'alert-circle',
  AlertTriangle = 'alert-triangle',
  Amex = 'amex',
  AppSubscription = 'app-subscription',
  ApplePay = 'apple-pay',
  Armoa = 'armoa',
  ArrowLeft = 'arrow-left',
  AwardWinning = 'award-winning',
  Award = 'award',
  Back = 'back',
  Biodynamic = 'biodynamic',
  BirthdayBonus = 'birthday-bonus',
  BlendType = 'blend-type',
  BottleGlass = 'bottle-glass',
  Bottle = 'bottle',
  Boxes = 'boxes',
  CalendarClock = 'calendar-clock',
  Calendar = 'calendar',
  Camera = 'camera',
  CapsLock = 'caps-lock',
  Cart = 'cart',
  Case = 'case',
  Check = 'check',
  Checkbox = 'Checkbox',
  Cheers = 'cheers',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Chocolate = 'chocolate',
  ChoiceCheck = 'choice-check',
  ChoiceUncheck = 'choice-uncheck',
  CircleChevronLeft = 'circle-chevron-left',
  CircleChevronRight = 'circle-chevron-right',
  ClearCircle = 'clear-circle',
  Close = 'close',
  ConvenientDelivery = 'convenient-delivery',
  CorkScrew = 'cork-screw',
  Coupons = 'coupons',
  CreditCard = 'credit-card',
  CustomerServices = 'customer-services',
  Customize = 'customize',
  CustomizedSelections = 'customized-selections',
  Delete = 'delete',
  Diamond = 'diamond',
  Discover = 'discover',
  DotMenu = 'dot-menu',
  DotsMenu = 'dots-menu',
  Droplet = 'droplet',
  Edit = 'edit',
  Email = 'email',
  EnvelopeBox = 'envelope-box',
  Envelope = 'envelope',
  Expand = 'expand',
  Eye = 'eye',
  Facebook = 'facebook',
  FileUser = 'file-user',
  Filter = 'filter',
  Flexibility = 'flexibility',
  FreeDelivery = 'free-delivery',
  Gift = 'gift',
  Glass = 'glass',
  Glasses = 'glasses',
  GooglePay = 'google-pay',
  Grape = 'grape',
  GreenTick = 'green-tick',
  HamburgerMenu = 'hamburger-menu',
  HandTruck = 'hand-truck',
  HeartSolid = 'heart-solid',
  Heart = 'heart',
  HelpCircle = 'help-circle',
  HidePassword = 'hide-password',
  Home = 'home',
  HomepageCustomisation = 'homepage-customisation',
  InfoCircle = 'info-circle',
  InformationCircle = 'information-circle',
  Instagram = 'instagram',
  Kosher = 'kosher',
  LabelScanner = 'label-scanner',
  LastSoldBg = 'last-sold-bg',
  LigntningSolid = 'ligntning-solid',
  LinkedIn = 'linked-in',
  LiveChat = 'live-chat',
  Location = 'location',
  Mastercard = 'mastercard',
  Menu = 'menu',
  Minus = 'minus',
  MoneyBackApac = 'money-back-apac',
  MoneyBackUs = 'money-back-us',
  MoneyBack = 'money-back',
  Mute = 'mute',
  NoObligation = 'no-obligation',
  OffsetCarbon = 'offset-carbon',
  Organic = 'organic',
  PackagingPioneer = 'packaging-pioneer',
  PadLockBenefits = 'pad-lock-benefits',
  Padlock = 'padlock',
  Pause = 'pause',
  Paypal = 'paypal',
  PhoneArrow = 'phone-arrow',
  PhoneSolid = 'phone-solid',
  Phone = 'phone',
  Pioneer = 'pioneer',
  Placeholder = 'placeholder',
  PlayVideo = 'play-video',
  Play = 'play',
  Print = 'print',
  QuestionCircle = 'question-circle',
  RadioSelected = 'radio-selected',
  Radio = 'radio',
  RedAlertCircleFilled = 'red-alert-circle-filled',
  RestaurantDishes = 'restaurant-dishes',
  Rossette = 'rossette',
  SaleTagBenefits = 'sale-tag-benefits',
  SaleTag = 'sale-tag',
  Sale = 'sale',
  SatisfactionGuarantee = 'satisfaction-guarantee',
  Saving = 'saving',
  Savings = 'savings',
  Search = 'search',
  Share = 'share',
  Sort = 'sort',
  StarSolid = 'star-solid',
  Star = 'star',
  StwcBlog = 'stwc-blog',
  SubscribeSave = 'subscribe-save',
  Sustainable = 'sustainable',
  Target = 'target',
  ThumbsDownSolid = 'thumbs-down-solid',
  ThumbsDown = 'thumbs-down',
  ThumbsUpSolid = 'thumbs-up-solid',
  ThumbsUp = 'thumbs-up',
  TickCircleSolid = 'tick-circle-solid',
  TickCircle = 'tick-circle',
  Ticket = 'ticket',
  Trending = 'trending',
  TruckBenefits = 'truck-benefits',
  TruckSolid = 'truck-solid',
  Truck = 'truck',
  Trust = 'trust',
  Twitter = 'twitter',
  UnidentifiedCountry = 'unidentified-country',
  Units = 'units',
  UnlimitedAvr = 'unlimited-avr',
  UnlimitedSale = 'unlimited-sale',
  UnlimitedSave = 'unlimited-save',
  UnlimitedStwc = 'unlimited-stwc',
  UnlimitedTruck = 'unlimited-truck',
  Unlimited = 'unlimited',
  UnltCheckIcon = 'unltCheckIcon',
  User = 'user',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  Views = 'views',
  Vinny = 'vinny',
  Visa = 'visa',
  Warning = 'warning',
  WineColour = 'wine-colour',
  WineGlass = 'wine-glass',
  World = 'world',
  XTwitter = 'x-twitter',
  Youtube = 'youtube',
  Zoom = 'zoom',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Abv]: '61697',
  [Icons.Add]: '61698',
  [Icons.AdvancedNotes]: '61699',
  [Icons.Alcohol]: '61700',
  [Icons.AlertCircleFilled]: '61701',
  [Icons.AlertCircle]: '61702',
  [Icons.AlertTriangle]: '61703',
  [Icons.Amex]: '61704',
  [Icons.AppSubscription]: '61705',
  [Icons.ApplePay]: '61706',
  [Icons.Armoa]: '61707',
  [Icons.ArrowLeft]: '61708',
  [Icons.AwardWinning]: '61709',
  [Icons.Award]: '61710',
  [Icons.Back]: '61711',
  [Icons.Biodynamic]: '61712',
  [Icons.BirthdayBonus]: '61713',
  [Icons.BlendType]: '61714',
  [Icons.BottleGlass]: '61715',
  [Icons.Bottle]: '61716',
  [Icons.Boxes]: '61717',
  [Icons.CalendarClock]: '61718',
  [Icons.Calendar]: '61719',
  [Icons.Camera]: '61720',
  [Icons.CapsLock]: '61721',
  [Icons.Cart]: '61722',
  [Icons.Case]: '61723',
  [Icons.Check]: '61724',
  [Icons.Checkbox]: '61725',
  [Icons.Cheers]: '61726',
  [Icons.ChevronDown]: '61727',
  [Icons.ChevronLeft]: '61728',
  [Icons.ChevronRight]: '61729',
  [Icons.ChevronUp]: '61730',
  [Icons.Chocolate]: '61731',
  [Icons.ChoiceCheck]: '61732',
  [Icons.ChoiceUncheck]: '61733',
  [Icons.CircleChevronLeft]: '61734',
  [Icons.CircleChevronRight]: '61735',
  [Icons.ClearCircle]: '61736',
  [Icons.Close]: '61737',
  [Icons.ConvenientDelivery]: '61738',
  [Icons.CorkScrew]: '61739',
  [Icons.Coupons]: '61740',
  [Icons.CreditCard]: '61741',
  [Icons.CustomerServices]: '61742',
  [Icons.Customize]: '61743',
  [Icons.CustomizedSelections]: '61744',
  [Icons.Delete]: '61745',
  [Icons.Diamond]: '61746',
  [Icons.Discover]: '61747',
  [Icons.DotMenu]: '61748',
  [Icons.DotsMenu]: '61749',
  [Icons.Droplet]: '61750',
  [Icons.Edit]: '61751',
  [Icons.Email]: '61752',
  [Icons.EnvelopeBox]: '61753',
  [Icons.Envelope]: '61754',
  [Icons.Expand]: '61755',
  [Icons.Eye]: '61756',
  [Icons.Facebook]: '61757',
  [Icons.FileUser]: '61758',
  [Icons.Filter]: '61759',
  [Icons.Flexibility]: '61760',
  [Icons.FreeDelivery]: '61761',
  [Icons.Gift]: '61762',
  [Icons.Glass]: '61763',
  [Icons.Glasses]: '61764',
  [Icons.GooglePay]: '61765',
  [Icons.Grape]: '61766',
  [Icons.GreenTick]: '61767',
  [Icons.HamburgerMenu]: '61768',
  [Icons.HandTruck]: '61769',
  [Icons.HeartSolid]: '61770',
  [Icons.Heart]: '61771',
  [Icons.HelpCircle]: '61772',
  [Icons.HidePassword]: '61773',
  [Icons.Home]: '61774',
  [Icons.HomepageCustomisation]: '61775',
  [Icons.InfoCircle]: '61776',
  [Icons.InformationCircle]: '61777',
  [Icons.Instagram]: '61778',
  [Icons.Kosher]: '61779',
  [Icons.LabelScanner]: '61780',
  [Icons.LastSoldBg]: '61781',
  [Icons.LigntningSolid]: '61782',
  [Icons.LinkedIn]: '61783',
  [Icons.LiveChat]: '61784',
  [Icons.Location]: '61785',
  [Icons.Mastercard]: '61786',
  [Icons.Menu]: '61787',
  [Icons.Minus]: '61788',
  [Icons.MoneyBackApac]: '61789',
  [Icons.MoneyBackUs]: '61790',
  [Icons.MoneyBack]: '61791',
  [Icons.Mute]: '61792',
  [Icons.NoObligation]: '61793',
  [Icons.OffsetCarbon]: '61794',
  [Icons.Organic]: '61795',
  [Icons.PackagingPioneer]: '61796',
  [Icons.PadLockBenefits]: '61797',
  [Icons.Padlock]: '61798',
  [Icons.Pause]: '61799',
  [Icons.Paypal]: '61800',
  [Icons.PhoneArrow]: '61801',
  [Icons.PhoneSolid]: '61802',
  [Icons.Phone]: '61803',
  [Icons.Pioneer]: '61804',
  [Icons.Placeholder]: '61805',
  [Icons.PlayVideo]: '61806',
  [Icons.Play]: '61807',
  [Icons.Print]: '61808',
  [Icons.QuestionCircle]: '61809',
  [Icons.RadioSelected]: '61810',
  [Icons.Radio]: '61811',
  [Icons.RedAlertCircleFilled]: '61812',
  [Icons.RestaurantDishes]: '61813',
  [Icons.Rossette]: '61814',
  [Icons.SaleTagBenefits]: '61815',
  [Icons.SaleTag]: '61816',
  [Icons.Sale]: '61817',
  [Icons.SatisfactionGuarantee]: '61818',
  [Icons.Saving]: '61819',
  [Icons.Savings]: '61820',
  [Icons.Search]: '61821',
  [Icons.Share]: '61822',
  [Icons.Sort]: '61823',
  [Icons.StarSolid]: '61824',
  [Icons.Star]: '61825',
  [Icons.StwcBlog]: '61826',
  [Icons.SubscribeSave]: '61827',
  [Icons.Sustainable]: '61828',
  [Icons.Target]: '61829',
  [Icons.ThumbsDownSolid]: '61830',
  [Icons.ThumbsDown]: '61831',
  [Icons.ThumbsUpSolid]: '61832',
  [Icons.ThumbsUp]: '61833',
  [Icons.TickCircleSolid]: '61834',
  [Icons.TickCircle]: '61835',
  [Icons.Ticket]: '61836',
  [Icons.Trending]: '61837',
  [Icons.TruckBenefits]: '61838',
  [Icons.TruckSolid]: '61839',
  [Icons.Truck]: '61840',
  [Icons.Trust]: '61841',
  [Icons.Twitter]: '61842',
  [Icons.UnidentifiedCountry]: '61843',
  [Icons.Units]: '61844',
  [Icons.UnlimitedAvr]: '61845',
  [Icons.UnlimitedSale]: '61846',
  [Icons.UnlimitedSave]: '61847',
  [Icons.UnlimitedStwc]: '61848',
  [Icons.UnlimitedTruck]: '61849',
  [Icons.Unlimited]: '61850',
  [Icons.UnltCheckIcon]: '61851',
  [Icons.User]: '61852',
  [Icons.Vegan]: '61853',
  [Icons.Vegetarian]: '61854',
  [Icons.Views]: '61855',
  [Icons.Vinny]: '61856',
  [Icons.Visa]: '61857',
  [Icons.Warning]: '61858',
  [Icons.WineColour]: '61859',
  [Icons.WineGlass]: '61860',
  [Icons.World]: '61861',
  [Icons.XTwitter]: '61862',
  [Icons.Youtube]: '61863',
  [Icons.Zoom]: '61864',
};
